<div fxLayoutAlign="center center" fxLayout="column" fxFlexFill>
  
  <form [formGroup]="formGroup">
    <div fxLayout="column" fxLayoutGap="25px">
  
      <!-- coupon_type -->
      <mat-form-field>
        <mat-label>
          {{ 'LABEL_COUPON_TYPE' | translate }}
        </mat-label>

        <mat-select id="id_coup_type_dropdown" formControlName="coupon_type" required>
          <mat-option [id]="'id_coup_type_data_' + (i+1)" *ngFor="let opt of couponTypes; let i = index" [value]="opt">
            {{opt.description}}
          </mat-option>
        </mat-select>

        <mat-error *ngIf="formGroup.controls['coupon_type'].hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>    
      </mat-form-field>
      
      <!-- pre_generated -->
      <div fxFlex *ngIf="formGroup.get('coupon_type').value?.code == '0'">      
        <mat-form-field>
          <input 
            id="id_qty_txtbox"
            matInput
            #pre_generated
            autocomplete="off" 
            formControlName="pre_generated" 
            [placeholder]="'LABEL_PRE_GENERATED' | translate"
            >
  
          <mat-error *ngIf="formGroup.controls['pre_generated'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error>    
                       
          <mat-error *ngIf="formGroup.controls['pre_generated'].hasError('min')">
            {{ 'MSG_MIN' | translate: {quantity: 1} }}
          </mat-error>
                       
          <mat-error *ngIf="formGroup.controls['pre_generated'].hasError('max')">
            {{ 'MSG_MAX' | translate: {quantity: pre_generated_max_qty} }}
          </mat-error>

          <mat-error *ngIf="formGroup.controls['pre_generated'].hasError('pattern')">
            {{ 'MSG_NUMBERS_ONLY' | translate }}
          </mat-error> 
        </mat-form-field>
      </div>
  
      <!-- on_demand -->
      <div fxFlex *ngIf="formGroup.get('coupon_type').value?.code == '1'">  
        <mat-form-field>
          <input 
            id="id_qty_txtbox"
            matInput
            #on_demand
            autocomplete="off" 
            formControlName="on_demand" 
            [placeholder]="'LABEL_ON_DEMAND' | translate"
            >
  
          <mat-error *ngIf="formGroup.controls['on_demand'].hasError('required')">
            {{ 'MSG_FIELD_REQUIRED' | translate }}
          </mat-error>   
                       
          <mat-error *ngIf="formGroup.controls['on_demand'].hasError('min')">
            {{ 'MSG_MIN' | translate: {quantity: 1} }}
          </mat-error> 
                       
          <mat-error *ngIf="formGroup.controls['on_demand'].hasError('max')">
            {{ 'MSG_MAX' | translate: {quantity: on_demand_max_qty} }}
          </mat-error> 

          <mat-error *ngIf="formGroup.controls['on_demand'].hasError('pattern')">
            {{ 'MSG_NUMBERS_ONLY' | translate }}
          </mat-error> 
        </mat-form-field>
      </div>
  
    </div>
  </form>
</div>